<h1 *ngIf="data.sectionName == 'gestioneProfiloProfessionale' && data.details.descrizioneArea.id != null"
    mat-dialog-title>AGGIORNAMENTO PROFILO
  PROFESSIONALE<mat-icon class="close-icon" (click)="onNoClick()">close</mat-icon></h1>
<h1 *ngIf="data.sectionName == 'gestioneProfiloProfessionale' && data.details.descrizioneArea.id == null"
    mat-dialog-title>CREAZIONE PROFILO
  PROFESSIONALE<mat-icon class="close-icon" (click)="onNoClick()">close</mat-icon></h1>
<div class="form-container" *ngIf="data.sectionName == 'gestioneProfiloProfessionale'">
  <form class="details-form">
    <mat-form-field class="half-width">
      <mat-label>Profilo professionale*</mat-label>
      <input matInput placeholder="Placeholder" [value]="data.details.nomeProfilo" name="nomeProfilo"
             [(ngModel)]="data.details.nomeProfilo" [disabled]="!data.permission">
    </mat-form-field>

    <mat-form-field class="half-width" appearance="fill">
      <mat-label>Area professionale*</mat-label>
      <mat-select name="descrizioneArea" [(ngModel)]="data.details.descrizioneArea.id"
                  [disabled]="!data.permission">
        <mat-option *ngFor="let item of data.selectData[0].options" [value]="item.id">
          {{item.descrizione}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="half-width-textarea margin-right">
      <mat-label>Descrizione profilo professionale*</mat-label>
      <textarea rows="5" matInput placeholder="Placeholder 2" [value]="data.details.descrizioneProfilo"
                name="descrizioneProfilo" [(ngModel)]="data.details.descrizioneProfilo"
                [disabled]="!data.permission"></textarea>
    </mat-form-field>
    <mat-form-field class="half-width-textarea">
      <mat-label>Elementi di contesto*</mat-label>
      <textarea rows="5" matInput placeholder="Placeholder 2" [value]="data.details.elementiContesto"
                name="elementiContesto" [(ngModel)]="data.details.elementiContesto"
                [disabled]="!data.permission"></textarea>
    </mat-form-field>
    <mat-form-field class="half-width margin-right">
      <mat-label>Livello EQF*</mat-label>
      <input type="number" min="0" matInput placeholder="Livello EQF"
             [value]="(data.details.livelloEqf != null) ? data.details.livelloEqf : 'Livello EQF non valorizzato'"
             name="livelloEqf" [(ngModel)]="data.details.livelloEqf" [disabled]="!data.permission">
    </mat-form-field>
    <mat-form-field class="half-width-textarea">
      <mat-label>Motivazioni relative all'inserimento della proposta</mat-label>
      <textarea rows="5" matInput placeholder="Legenda" [value]="data.details.motivazioniProposta"
                name="motivazioniProposta" [(ngModel)]="data.details.motivazioniProposta"
                [disabled]="!data.permission"></textarea>
    </mat-form-field>


  </form>
  <div class="legend">
    <p>Motivazioni relative all'inserimento della proposta a titolo esemplificativo:</p>
    <ul>
      <li>richieste del mercato del lavoro</li>
      <li>progetti specifici</li>
      <li>riferimenti a normative vigenti</li>
      <li>ecc</li>
    </ul>
  </div>
</div>

<!-- DUPLICA PROFILO -->

<h1 *ngIf="data.type == 'duplica_profilo'" mat-dialog-title>DUPLICA PROFILO
  PROFESSIONALE<mat-icon class="close-icon" (click)="onNoClick()">close</mat-icon></h1>
<div class="form-container" *ngIf="data.type == 'duplica_profilo'">
  <form class="details-form">
    <mat-form-field class="half-width">
      <mat-label>Profilo professionale*</mat-label>
      <input matInput placeholder="Placeholder" [value]="data.details.nomeProfilo" name="nomeProfilo"
             [(ngModel)]="data.details.nomeProfilo" [disabled]="!data.permission">
    </mat-form-field>

    <mat-form-field class="half-width" appearance="fill">
      <mat-label>Area professionale*</mat-label>
      <mat-select name="descrizioneArea" [(ngModel)]="data.details.descrizioneArea.id"
                  [disabled]="!data.permission">
        <mat-option *ngFor="let item of data.selectData[0].options" [value]="item.id">
          {{item.descrizione}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="half-width-textarea margin-right">
      <mat-label>Descrizione profilo professionale*</mat-label>
      <textarea rows="5" matInput placeholder="Placeholder 2" [value]="data.details.descrizioneProfilo"
                name="descrizioneProfilo" [(ngModel)]="data.details.descrizioneProfilo"
                [disabled]="!data.permission"></textarea>
    </mat-form-field>
    <mat-form-field class="half-width-textarea">
      <mat-label>Elementi di contesto*</mat-label>
      <textarea rows="5" matInput placeholder="Placeholder 2" [value]="data.details.elementiContesto"
                name="elementiContesto" [(ngModel)]="data.details.elementiContesto"
                [disabled]="!data.permission"></textarea>
    </mat-form-field>
    <mat-form-field class="half-width margin-right">
      <mat-label>Livello EQF*</mat-label>
      <input type="number" min="0" matInput placeholder="Livello EQF"
             [value]="(data.details.livelloEqf != null) ? data.details.livelloEqf : 'Livello EQF non valorizzato'"
             name="livelloEqf" [(ngModel)]="data.details.livelloEqf" [disabled]="!data.permission">
    </mat-form-field>
    <mat-form-field class="half-width-textarea">
      <mat-label>Motivazioni relative all'inserimento della proposta</mat-label>
      <textarea rows="5" matInput placeholder="Legenda" [value]="data.details.motivazioniProposta"
                name="motivazioniProposta" [(ngModel)]="data.details.motivazioniProposta"
                [disabled]="!data.permission"></textarea>
    </mat-form-field>


  </form>
  <div class="legend">
    <p>Motivazioni relative all'inserimento della proposta a titolo esemplificativo:</p>
    <ul>
      <li>richieste del mercato del lavoro</li>
      <li>progetti specifici</li>
      <li>riferimenti a normative vigenti</li>
      <li>ecc</li>
    </ul>
  </div>
</div>


<!-- COMPETENZE -->
<h1 *ngIf="data.sectionName == 'gestioneCompetenze' && data.details.tipologia.id != null" mat-dialog-title>AGGIORNAMENTO COMPETENZE<mat-icon class="close-icon" (click)="onNoClick()">close</mat-icon></h1>
<h1 *ngIf="data.sectionName == 'gestioneCompetenze' && data.details.tipologia.id == null" mat-dialog-title>CREAZIONE COMPETENZA<mat-icon class="close-icon" (click)="onNoClick()">close</mat-icon></h1>

<div class="form-container" *ngIf="data.sectionName == 'gestioneCompetenze'">
  <form class="details-form">

    <mat-form-field class="half-width margin-right" appearance="fill">
      <mat-label>Tipologia *</mat-label>
      <mat-select name="tipologia" [(ngModel)]="data.details.tipologia.id" [disabled]="!data.permission || data.isProfilo"
                  placeholder="Tipologia">
        <mat-option *ngFor="let item of data.selectData[0].options" [value]="item.id">
          {{item.descrizione}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="data.details.tipologia.id === 3" class="half-width" appearance="fill">
      <mat-label>Sottocategoria *</mat-label>
      <mat-select name="Sottocategoria" [(ngModel)]="data.details.idTCategoriaBase" [disabled]="!data.permission"
                  placeholder="Sottocategoria competenza di base">
        <mat-option *ngFor="let item of data.selectData[2].options" [value]="item.id">
          {{item.descrizione}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="data.details.tipologia.id === 6" class="half-width" appearance="fill">
      <mat-label>Sottocategoria *</mat-label>
      <mat-select name="Sottocategoria" [(ngModel)]="data.details.idTCategoriaDigitale" [disabled]="!data.permission"
                  placeholder="Sottocategoria competenza digitale">
        <mat-option *ngFor="let item of data.selectData[4].options" [value]="item.id">
          {{item.descrizione}}
        </mat-option>
      </mat-select>
    </mat-form-field>


    <mat-form-field class="half-width" appearance="fill"
                    *ngIf="data.details.tipoArea != null && data.details.tipologia.id == 1">
      <mat-label>Area professionale*</mat-label>
      <mat-select name="area" [(ngModel)]="data.details.tipoArea.id" [disabled]="!data.permission"
                  placeholder="Area professionale">
        <mat-option *ngFor="let item of data.selectData[1].options" [value]="item.id">
          {{item.descrizione}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="half-width-textarea margin-right">
      <mat-label>Descrizione*</mat-label>
      <textarea rows="5" matInput placeholder="Ds competenza" [value]="data.details.descrizione"
                name="descrizione" [(ngModel)]="data.details.descrizione" [disabled]="!data.permission"></textarea>
    </mat-form-field>

    <mat-form-field class="half-width">
      <mat-label>Livello EQF*</mat-label>
      <input type="number" min="0" matInput placeholder="Livello EQF"
             [value]="(data.details.eqfCompetenza != null) ? data.details.eqfCompetenza : 'Livello EQF non valorizzato'"
             name="eqfCompetenza" [(ngModel)]="data.details.eqfCompetenza" [disabled]="!data.permission">
    </mat-form-field>

    <mat-form-field *ngIf="data.details.tipologia.id === 1 || data.details.tipologia.id === 6" class="half-width-textarea margin-right">
      <mat-label>Info sulla competenza*</mat-label>
      <textarea rows="5" matInput placeholder="Info competenza" [value]="data.details.informazioniCompetenza"
                name="informazioniCompetenza" [(ngModel)]="data.details.informazioniCompetenza" [disabled]="!data.permission"></textarea>
    </mat-form-field>


  </form>

</div>

<!-- UTENZE -->
<h1 *ngIf="data.sectionName == 'gestioneUtenze'" mat-dialog-title>AGGIORNAMENTO UTENTE<mat-icon class="close-icon"
                                                                                                (click)="onNoClick()">close</mat-icon></h1>
<div class="form-container" *ngIf="data.sectionName == 'gestioneUtenze'">
  <form class="details-form">
    <mat-form-field class="half-width margin-right">
      <mat-label>Codice Fiscale</mat-label>
      <input matInput placeholder="Codice Fiscale" required value="{{data.details.codiceFiscale}}"
             [(ngModel)]="data.details.codiceFiscale" name="cf"
             [pattern]="'^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$'">
    </mat-form-field>


      <mat-slide-toggle [checked]="data.details.flAttivo" (change)="setFlAttivo()">
        Attivo
      </mat-slide-toggle>

    <mat-form-field class="half-width margin-right">
      <mat-label>Nome</mat-label>
      <input matInput placeholder="Nome" required value="{{data.details.nomeUtente}}" [(ngModel)]="data.details.nomeUtente"
             name="nome">
    </mat-form-field>

    <mat-form-field class="half-width">
      <mat-label>Cognome</mat-label>
      <input matInput placeholder="Cognome" required value="{{data.details.cognomeUtente}}"
             [(ngModel)]="data.details.cognomeUtente" name="cognome">
    </mat-form-field>
    <hr class="divider">

    <div class="full-width">
      <div class="half-width margin-right">
        <mat-form-field class="full-width">
          <mat-label>Tel</mat-label>
          <input class="custom-input telephone" type="number" matInput placeholder="Telefono" value="{{telefono}}"
                 [(ngModel)]="telefono" name="telefono">
          <mat-icon class="input-icon" (click)="addTel(telefono)">add</mat-icon>
        </mat-form-field>
        <mat-list role="list">
          <mat-list-item *ngFor="let tel of data.details.listaTelefoni; index as i" role="listitem">
            <strong class="left">Tel {{i+1}}:</strong>&nbsp; <span
            class="grey fixed-width">{{tel.descrizione}}</span>
            <mat-icon class="cancel-icon" (click)="removeTel(i)">cancel</mat-icon>
          </mat-list-item>
        </mat-list>
      </div>
      <div class="half-width">
        <mat-form-field class="full-width">
          <mat-label>Fax</mat-label>
          <input class="custom-input" matInput placeholder="Fax" value="{{fax}}" [(ngModel)]="fax" name="fax">
          <mat-icon class="input-icon" (click)="addFax(fax)">add</mat-icon>
        </mat-form-field>
        <mat-list role="list">
          <mat-list-item *ngFor="let fax of data.details.listaFax; index as i" role="listitem">
            <strong class="left">Fax {{i+1}}:</strong>&nbsp; <span
            class="grey fixed-width">{{fax.descrizione}}</span>
            <mat-icon class="cancel-icon" (click)="removeFax(i)">cancel</mat-icon></mat-list-item>
        </mat-list>
      </div>

    </div>
    <div class="full-width">
      <div class="half-width margin-right">
        <mat-form-field class="full-width">
          <mat-label>Email</mat-label>
          <input class="custom-input" matInput placeholder="Email" value="{{email}}" [(ngModel)]="email"
                 name="email">
          <mat-icon class="input-icon" (click)="addEmail(email)">add</mat-icon>
        </mat-form-field>
        <mat-list role="list">
          <mat-list-item *ngFor="let email of data.details.listaEmail; index as i" role="listitem">
            <strong class="left">Email {{i+1}}:</strong>&nbsp; <span
            class="grey fixed-width">{{email.descrizione}}</span>
            <mat-icon class="cancel-icon" (click)="removeEmail(i)">cancel</mat-icon>
          </mat-list-item>
        </mat-list>
      </div>
      <div class="half-width">
        <mat-label><strong>Sesso</strong></mat-label>
        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                         [(ngModel)]="data.details.sesso" [value]="data.details.sesso" name="sex"
                         (change)="changeSex($event)">
          <mat-radio-button class="example-radio-button" value="M">
            M
          </mat-radio-button>
          <mat-radio-button class="example-radio-button" value="F">
            F
          </mat-radio-button>
        </mat-radio-group>
      </div>

    </div>

    <hr class="divider">
    <div class="full-width">
      <div class="half-width margin-right">
        <mat-form-field class="full-width" appearance="fill">
          <mat-label>Ruolo</mat-label>
          <mat-select (selectionChange)="getOperatore($event.value)" required name="ruolo" [(ngModel)]="ruolo.id"
                      [disabled]="!data.permission">

            <mat-option *ngFor="let item of listaRuoli" [value]="item.id">
              {{item.descrizione}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="half-width icon-right" *ngIf="listaOperatori && listaOperatori.length > 0 && ruolo.id == 10">
        <mat-form-field class="full-width" appearance="fill">
          <mat-label>Operatore *</mat-label>
          <mat-select name="operatore" [(ngModel)]="operatore" [disabled]="!data.permission" (selectionChange)="selezionaOperatore(operatore)">
            <mat-option *ngFor="let item of listaOperatori" [value]="item">
              {{item.descrizione}}
            </mat-option>
          </mat-select>

        </mat-form-field>
        <!-- <mat-icon class="input-icon external" (click)="addRuolo(ruolo,operatore)">add</mat-icon> -->
        <mat-icon class="input-icon external" (click)="inserisciOperatore(ruolo)">person_add</mat-icon>
      </div>
    </div>
    <!--<div class="full-width">
      <div class="half-width margin-right">

        <mat-list role="list">
          <mat-list-item *ngFor="let ruolo of data.details.listaRuoli; index as i" role="listitem">
            <strong class="left">Ruolo {{i+1}}:</strong>&nbsp; <span
            class="grey fixed-width">{{ruolo.descrizione}}</span>
            <mat-icon class="cancel-icon" (click)="removeRuolo(i)">cancel</mat-icon>
          </mat-list-item>
        </mat-list>

      </div>

    </div>-->
  </form>
</div>
<!-- ASSEMBLEA -->
<h1 *ngIf="data.sectionName == 'gestioneAssemblea' && data.type != 'new'" mat-dialog-title>VISUALIZZA ASSEMBLEA<mat-icon
  class="close-icon" (click)="onNoClick()">close</mat-icon></h1>
<h1 *ngIf="data.sectionName == 'gestioneAssemblea' && data.type == 'new'" mat-dialog-title>NUOVA ASSEMBLEA<mat-icon
  class="close-icon" (click)="onNoClick()">close</mat-icon></h1>
<div class="form-container" *ngIf="data.sectionName == 'gestioneAssemblea'">
  <form class="details-form">
    <mat-form-field class="half-width margin-right">

      <mat-label>Data riunione</mat-label>

      <input matInput [matDatepicker]="riunione" placeholder="Data riunione" required disabled name="datepicker_riunione"
             [(ngModel)]="data.details.dataRiunione">

      <mat-datepicker-toggle matIconSuffix [for]="riunione"></mat-datepicker-toggle>
      <mat-datepicker #riunione
                      [disabled]="(data.type == 'edit_decreto') || (data.type != 'new' && data.details.stato.id != 1)"></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="half-width">

      <mat-label>Data approvazione</mat-label>

      <input matInput [matDatepicker]="approvazione" required placeholder="Data approvazione" disabled
             name="datepicker_approvazione" [(ngModel)]="data.details.dataApprovazione">

      <mat-datepicker-toggle matIconSuffix [for]="approvazione"></mat-datepicker-toggle>
      <mat-datepicker #approvazione
                      [disabled]="(data.type == 'edit_decreto') || (data.type != 'new' && data.details.stato.id != 1)"></mat-datepicker>
    </mat-form-field>
    <!-- <mat-form-field class="half-width" *ngIf="data.type != 'edit_decreto'">
        <mat-label>Data approvazione</mat-label>
        <input matInput placeholder="Data approvazione" [matDatepicker]="approvazione" name="datepicker"
            [(ngModel)]="data.details.dataApprovazione" [disabled]="data.type != 'edit_decreto' && data.type != 'new'">
        <mat-datepicker-toggle matIconSuffix [for]="approvazione"></mat-datepicker-toggle>
        <mat-datepicker #approvazione [disabled]="data.type != 'edit_decreto' && data.type != 'new'"></mat-datepicker>
    </mat-form-field> -->

    <mat-form-field class="full-width-textarea">
      <mat-label>Descrizione</mat-label>
      <textarea rows="5" matInput placeholder="Descrizione" [value]="data.details.descrizione" name="descrizione" required
                [(ngModel)]="data.details.descrizione"
                [disabled]="(data.type == 'edit_decreto') || (data.type != 'new' && data.details.stato.id != 1)"></textarea>
    </mat-form-field>

    <mat-form-field class="half-width" *ngIf="data.type != 'new' && data.details.stato.id != 1">

      <mat-label>Data decreto</mat-label>

      <input matInput [matDatepicker]="decreto" placeholder="Data decreto" disabled name="datepicker_decreto"
             [(ngModel)]="data.details.dataDecreto">

      <mat-datepicker-toggle matIconSuffix [for]="decreto"></mat-datepicker-toggle>
      <mat-datepicker #decreto
                      [disabled]="data.type != 'edit_decreto' && data.type != 'new' && data.details.stato.id != 1"></mat-datepicker>

    </mat-form-field>

    <mat-form-field class="full-width-textarea" *ngIf="data.details.stato.id == 2">
      <mat-label>Nome decreto</mat-label>
      <textarea required rows="5" matInput placeholder="Nome decreto" [value]="data.details.nomeDecreto" name="nomeDecreto"
                [(ngModel)]="data.details.nomeDecreto"
                [disabled]="data.type != 'edit_decreto' && data.type != 'new' && data.details.stato.id != 1"></textarea>
    </mat-form-field>

    <ng-container *ngIf="data.details.stato.id == 2">
      <label for="fileInput">Carica decreto *</label>
      <input type="file" id="fileInput" class="file-upload ml-10" (change)="onFileSelected($event)" accept=".pdf">
    </ng-container>

    <p class="decreto" (click)="downloadDecreto(data.details.idDocumentoDecreto)"
       *ngIf="data.details.idDocumentoDecreto != null">
      <!-- <mat-icon>download</mat-icon><span>DOCUMENTO DECRETO</span> -->
      <mat-icon>download</mat-icon><span>Id Documento: {{data.details.idDocumentoDecreto}}</span>
    </p>
  </form>
</div>

<!-- OPERATORI -->

<div *ngIf="data.sectionName == 'gestioneOperatori'">
  <h1 mat-dialog-title>{{ data.type === 'edit' ? 'AGGIORNAMENTO' : 'NUOVO' }} OPERATORE<mat-icon class="close-icon"
                                                        (click)="onNoClick()">close</mat-icon></h1>
  <div class="form-container" >
    <form class="details-form">
      <mat-form-field class="half-width margin-right">
        <mat-label>Id Operatore *</mat-label>
        <input matInput placeholder="Id Operatore" value="{{data.details.id}}"
               [(ngModel)]="data.details.id" name="id" type="number">
      </mat-form-field>

      <mat-form-field class="half-width">
        <mat-label>Descrizione *</mat-label>
        <input matInput placeholder="Descrizione" value="{{data.details.descrizione}}"
               [(ngModel)]="data.details.descrizione" name="descrizione">
      </mat-form-field>

      <mat-form-field class="half-width margin-right">
        <mat-label>Indirizzo *</mat-label>
        <input matInput placeholder="Indirizzo" value="{{data.details.indirizzo}}"
               [(ngModel)]="data.details.indirizzo" name="indirizzo">
      </mat-form-field>

      <mat-form-field class="half-width">
        <mat-label>CAP</mat-label>
        <input matInput placeholder="CAP" value="{{data.details.cap}}" [(ngModel)]="data.details.cap" name="cap"  type="number">
      </mat-form-field>

      <div class="full-width">
        <div class="half-width margin-right">
          <mat-form-field class="full-width" appearance="fill">
            <mat-label>Provincia *</mat-label>
            <mat-select (selectionChange)="getComuni(data.details.cmbProvincia.id)" name="provincia"
                        [(ngModel)]="data.details.cmbProvincia.id" [disabled]="!data.permission">
              <mat-option *ngFor="let item of listaProvince" [value]="item.id">
                {{item.descrizione}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="half-width" *ngIf="listaComuni && listaComuni.length > 0">
          <mat-form-field class="full-width" appearance="fill">
            <mat-label>Comune *</mat-label>
            <mat-select name="comune" [(ngModel)]="data.details.cmbComune.id" [disabled]="!data.permission">
              <mat-option *ngFor="let item of listaComuni" [value]="item.id">
                {{item.descrizione}}
              </mat-option>
            </mat-select>

          </mat-form-field>

        </div>

      </div>
      <div class="full-width">
        <div class="half-width">
          <mat-form-field class="full-width" appearance="fill">
            <mat-label>Tipo Operatore</mat-label>
            <mat-select name="tipoOperatore" [(ngModel)]="data.details.tipoOperatore.id" [disabled]="!data.permission">
              <mat-option *ngFor="let item of listaTipoOperatori" [value]="item.id">
                {{item.descrizione}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label><strong>Attivo *</strong></mat-label>
          <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                           [(ngModel)]="data.details.flagAttivo" [value]="data.details.flagAttivo" name="flagAttivo"
                           (change)="changeAttivo($event)">
            <mat-radio-button class="example-radio-button" value="1">
              Si
            </mat-radio-button>
            <mat-radio-button class="example-radio-button" value="0">
              No
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="full-width" >
        <span  matTooltip="Per aggiungere una sede, valorizzare l'id operatore"><button style="margin-top:20px; margin-bottom:20px;" mat-fab extended class="searchbox-buttons save-button"
            [disabled]="!data.details.id"  (click)="apriSede($event)">
         Aggiungi sede
        </button></span>
      </div>

      <div class="full-width">

        <div class="half-width margin-right">

          <mat-list role="list">
            <mat-list-item *ngFor="let sede of data.details.listaSedi; index as i" role="listitem">
              <strong class="left">Sede {{i+1}}:</strong>&nbsp; <span
              class="grey fixed-width">{{sede.descrizione}}</span>
              <mat-icon class="cancel-icon" (click)="removeSede(i)">cancel</mat-icon>
            </mat-list-item>
          </mat-list>

        </div>

      </div>

    </form>


  </div>
</div>



<div mat-dialog-actions class="actions">
  <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="onNoClick()">
    <mat-icon>close</mat-icon>Chiudi
  </button>
  <button mat-fab extended class="searchbox-buttons save-button" [mat-dialog-close]="data"
          [disabled]="!data.permission || cantSaveDettaglio()">
    <mat-icon>save</mat-icon>Salva
  </button>
</div>

